module.exports = {
	"name": "eureka-browser",
	"description": "Eureka is a progressively enhanced Media Browser Component.",
	"version": "0.0.130",
	"license": "BSD-3-Clause",
	"author": {
		"name": "JP de Vries",
		"email": "mail@devries.jp",
		"url": "https://devries.jp/"
	},
	"proxy": "http://localhost:3001/",
	"main": "dist/main.js",
	"config": {
		"port": "3000"
	},
	"keywords": [
		"react",
		"redux",
		"media",
		"browse",
		"eureka",
		"MODX",
		"a11y",
		"data",
		"table"
	],
	"homepage": "https://eureka.markup.tips",
	"bugs": {
		"url": "https://github.com/jpdevries/eureka/issues",
		"email": "eureka@devries.jp"
	},
	"repository": {
		"type": "git",
		"url": "https://github.com/jpdevries/eureka.git"
	},
	"files": [
		"bower.json",
		"yarn.lock",
		"build/assets/css/eureka.*",
		"build/assets/img/",
		"build/assets/js/",
		"build/static/",
		"dist/",
		"i18n/",
		"src/"
	],
	"devDependencies": {
		"autoprefixer": "^7.1.2",
		"concurrently": "^3.5.0",
		"css-loader": "^0.28.4",
		"cssnano": "^3.10.0",
		"eslint": "^4.3.0",
		"eslint-plugin-jsx-a11y": "^6.0.2",
		"grunt-bower-task": "^0.4.0",
		"grunt-contrib-clean": "^1.1.0",
		"grunt-contrib-copy": "^1.0.0",
		"grunt-contrib-cssmin": "^2.2.1",
		"grunt-contrib-uglify": "^3.0.1",
		"grunt-contrib-watch": "^1.0.0",
		"grunt-growl": "^0.1.5",
		"grunt-modernizr": "^1.0.2",
		"grunt-postcss": "^0.8.0",
		"grunt-sass": "^2.0.0",
		"grunt-string-replace": "^1.3.1",
		"grunt-svgmin": "^4.0.0",
		"grunt-svgo": "^0.1.0",
		"grunt-svgstore": "^1.0.0",
		"grunt-webpack": "^3.0.2",
		"json-loader": "^0.5.7",
		"lazyload-script": "^1.0.0",
		"postcss-custom-properties": "^6.1.0",
		"postcss-focus-ring": "^1.0.0",
		"react-scripts": "*",
		"react-tap-event-plugin": "^2.0.1",
		"react-test-renderer": "^15.6.1",
		"style-loader": "^0.18.2",
		"webpack-dev-server": "^2.6.1",
		"webpack-visualizer-plugin": "^0.1.11"
	},
	"dependencies": {
		"babel-plugin-react-intl": "^2.3.1",
		"babel-preset-es2015": "^6.24.1",
		"babel-preset-react": "^6.24.1",
		"babel-preset-stage-0": "^6.24.1",
		"classnames": "^2.2.5",
		"css-safe": "^0.1.0",
		"filesize": "^3.5.10",
		"html-entities": "^1.2.1",
		"isomorphic-fetch": "^2.2.1",
		"mousetrap": "^1.6.1",
		"path-parse": "^1.0.5",
		"pixrem": "^4.0.1",
		"react": "next",
		"react-addons-update": "^15.6.0",
		"react-cropperjs": "^1.2.5",
		"react-dom": "next",
		"react-dropzone": "^3.13.4",
		"react-intl": "^2.3.0",
		"react-masonry-component": "^5.0.7",
		"react-redux": "next",
		"react-worker-dom": "^2.0.0-alpha.6",
		"redux": "^3.7.2",
		"redux-thunk": "^2.2.0"
	},
	"scripts": {
		"start": "react-scripts start",
		"build": "yarn i18n && react-scripts build",
		"test": "react-scripts test --env=jsdom",
		"eject": "react-scripts eject",
		"babel": "babel ./src -d ./dist",
		"i18n": "cd ./i18n && node build.js && cd ../",
		"pretag": "grunt bump && grunt clean:buildcss && grunt clean:themecss && yarn i18n && grunt buildcss && yarn build && rm -rf public/assets/css && grunt clean:buildjs && grunt build && yarn babel",
		"pretagsay": "yarn pretag && say \"Eureka Prepared for Tagging\""
	}
};


//////////////////
// WEBPACK FOOTER
// ./package.json
// module id = 759
// module chunks = 0